import { Resource, ResourceProps } from 'ia-react-core';
import React, { FC } from 'react';
import { AccountConsents } from '../../interfaces/AccountConsents';
import { getProfileApiRoot } from '../../utils/getProfileApiRoot';

interface AcceptTermsOfUseResourceProps extends ResourceProps<AccountConsents> {
  termsOfUseConsents: AccountConsents;
}

const AcceptTermsOfUseResource: FC<AcceptTermsOfUseResourceProps> = ({ termsOfUseConsents, ...props }) => (
  <Resource
    name="/App.features.termsOfUse.acceptTermsOfUseResource"
    url={`${getProfileApiRoot()}/account/consents`}
    method="PUT"
    {...props}
    transformRequest={() => ({ ...termsOfUseConsents?.data, termsOfUseConsent: true })}
  />

);
export default AcceptTermsOfUseResource;
